const isDev = import.meta.env.DEV

if (!isDev) {
  console.log = () => undefined
}

export {}
